import { createReducer } from '@reduxjs/toolkit';
import { fetchImpersonation } from './actions';
import { initialState } from './types';

export default createReducer(initialState, builder => {
  builder
    .addCase(fetchImpersonation.pending, state => {
      state.pending = true;
      state.error = false;
    })
    .addCase(fetchImpersonation.fulfilled, (state, { payload }) => {
      state.pending = false;
      state.fullfilled = true;
      state.isImpersonating = !!(payload?.isImpersonating && payload.target);
      state.target = state.isImpersonating ? payload.target ?? null : null;
      state.admin = state.isImpersonating ? payload.admin ?? null : null;
    })
    .addCase(fetchImpersonation.rejected, state => {
      state.pending = false;
      state.error = true;
      state.isImpersonating = false;
      state.target = null;
      state.admin = null;
    });
});
